import React, { useState, useEffect } from "react";
import { Route, BrowserRouter as Router, Routes, useLocation, useNavigate } from "react-router-dom";
import { App as CapApp } from "@capacitor/app";
import Home from "./screens/home";
import DonationBill from "./screens/donationbill";
import Taxbill from "./screens/taxbill";
import DonationList from "./screens/donationlist";
import Taxlist from "./screens/taxlist";
import KumbaTaxbill from "./screens/kumbataxbill";
import KumbaDonationBill from "./screens/kumbadonationbill";
import KumbaTaxlist from "./screens/kumbataxlist";
import KumbaDonationList from "./screens/kumbadonationlist";
import Layout from "./components/layout";
import Login from "./screens/login";

function AndroidBackButtonHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let backHandle = null;

    const setupListener = async () => {
      try {
        backHandle = await CapApp.addListener("backButton", ({ canGoBack }) => {
          // If on home/root screen, exit app
          if (location.pathname === "/" || location.pathname === "") {
            CapApp.exitApp();
          } else if (canGoBack || window.history.length > 1) {
            // Go back one step in history
            navigate(-1);
          } else {
            // Fallback to home screen
            navigate("/");
          }
        });
      } catch (err) {
        console.warn("Capacitor App plugin listener failed:", err);
      }
    };

    setupListener();

    return () => {
      if (backHandle) {
        backHandle.remove();
      }
    };
  }, [location.pathname, navigate]);

  return null;
}

function MainNavigation() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      let handle = null;
      CapApp.addListener("backButton", () => {
        CapApp.exitApp();
      }).then((h) => {
        handle = h;
      }).catch(() => {});

      return () => {
        if (handle) {
          handle.remove();
        }
      };
    }
  }, [isAuthenticated, isLoading]);

  const checkAuth = () => {
    const authDataStr = localStorage.getItem("temple_auth");
    if (authDataStr) {
      try {
        const authData = JSON.parse(authDataStr);
        if (authData.isLoggedIn && authData.expiry > new Date().getTime()) {
          setIsAuthenticated(true);
        } else {
          // Token expired
          localStorage.removeItem("temple_auth");
          setIsAuthenticated(false);
        }
      } catch (e) {
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    setIsLoading(false);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <Router>
      <AndroidBackButtonHandler />
      <Layout>
        <Routes>
          <Route Component={Home} path="/" />
          <Route path="/donation">
            <Route Component={DonationBill} path="bill" />
            <Route Component={DonationList} path="list" />
          </Route>
          <Route path="/tax">
            <Route Component={Taxbill} path="bill" />
            <Route Component={Taxlist} path="list" />
          </Route>
          <Route path="/kumba/donation">
            <Route Component={KumbaDonationBill} path="bill" />
            <Route Component={KumbaDonationList} path="list" />
          </Route>
          <Route path="/kumba/tax">
            <Route Component={KumbaTaxbill} path="bill" />
            <Route Component={KumbaTaxlist} path="list" />
          </Route>
        </Routes>
      </Layout>
    </Router>
  );
}

export default MainNavigation;
